let Tools = {
  init: function() {
    if (this.detectIE() || this.detectOpera()) {              
      let elem = $('<div id="ie-box"></div>');
      elem.css({
        'position' : 'fixed',
        'top' : '50%',
        'left' : '50%',
        'width' : '65%',
        'text-align': 'left',
        'background' : 'white',
        'border' : '3px solid red',
        'padding' : '0.5rem 1rem',
        'transform' : 'translate(-50%, -50%)',
        'z-index' : '999',
        'font-size' : '16px',
        'font-weight' : '700'
      });

      //<a href='https://support.apple.com/downloads/safari' target='_blank'>Safari</a>
      elem.html("Your browser is not supported. For an optimal experience, please upgrade to the latest version of <a href='https://www.google.com/chrome/' target='_blank'><u>Chrome</u></a>, <a href='https://www.microsoft.com/en-us/edge' target='_blank'><u>Edge</u></a>  or some other modern browser.");
      
      $('body').append(elem);
    }
  },
  
  detectOpera: function() {
    return (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  },
  
  detectIE: function() {
    var ua = window.navigator.userAgent;
    
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {      
      return true;
    }
  
    var trident = ua.indexOf('Trident/');
    if (trident > 0) {      
      var rv = ua.indexOf('rv:');      
      return true;
    }
          
    return false;
  }
}

$(function() {
  Tools.init();
})